import axios, { type AxiosError } from "axios";

const api = axios.create({
  baseURL: `${process.env.API_URL || ""}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let onUnauthorized: (() => void) | null = null;

export function setOnUnauthorized(cb: () => void) {
  onUnauthorized = cb;
}

api.interceptors.response.use(
  (res) => res,
  (err: AxiosError) => {
    if (err.response?.status === 401 && !err.config?.url?.includes("/auth/")) {
      onUnauthorized?.();
    }
    return Promise.reject(err);
  },
);

export function extractErrorMessage(
  err: unknown,
  fallback = "Something went wrong. Please try again.",
): string {
  if (axios.isAxiosError(err)) {
    const data = err.response?.data as
      { message?: string | string[] } | undefined;
    if (data?.message) {
      const msg = Array.isArray(data.message)
        ? data.message.join(", ")
        : data.message;
      if (typeof msg === "string" && msg.trim()) return msg.trim();
    }
    if (err.response?.status === 404) {
      return "We could not find what you were looking for.";
    }
    if (err.response?.status === 403) {
      return "You do not have permission to do that.";
    }
    if (err.response?.status && err.response.status >= 500) {
      return "The server had a problem. Please try again in a moment.";
    }
    if (err.message?.trim()) return err.message.trim();
    return fallback;
  }
  if (err instanceof Error && err.message.trim()) return err.message.trim();
  return fallback;
}

export default api;
